import { Component } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';

interface IFundWalletModalContext {
  account: any;
}
@Component({
  selector: 'app-fund-wallet-modal',
  templateUrl: './fund-wallet-modal.component.html',
  styleUrls: ['./fund-wallet-modal.component.scss'],
})
export class FundWalletModalComponent {
  error: any;
  success: any;
  pending: boolean = false;
  amount: number;

  fundWalletForm: FormGroup;

  constructor(
    public modal: SuiModal<IFundWalletModalContext, void, void>,
    private router: Router,
    private walletService: EwalletService,
    private fb: FormBuilder
  ) {
    this.fundWalletForm = fb.group({
      amount: [
        '',
        [
          Validators.required,
          Validators.maxLength(11),
          Validators.pattern(/[0-9]/),
        ],
      ],
    });
    console.log(modal.context.account);
  }

  submit() {
    if (
      !this.fundWalletForm.value.amount ||
      this.fundWalletForm.value.amount <
        this.modal.context.account.minFundingAmount
    ) {
      this.error =
        'The  Amount to Fund is less than the minimum funding amount';
      return;
    }
    this.pending = true;
    const user = JSON.parse(localStorage.getItem('user'));
    const body = {
      nccId:
        this.modal.context.account.nccId ||
        JSON.parse(this.modal.context.account).nccId,
      amount: this.fundWalletForm.value.amount,
      createdBy: {
        appUserId: user.appUserId,
        username: user.username,
        name: user.firstName,
      },
      currencyId:
        this.modal.context.account.currencyId ||
        JSON.parse(this.modal.context.account).currencyId,
    };
    console.log({ body });
    this.walletService.fundWallet({ body }).subscribe(
      (res) => {
        this.modal.approve(null);
        const params = {
          id: res['initiatedPaymentId'],
          paymentUrl: res['paymentUrl'],
          purpose: 'eWallet Funding',
          amount: this.fundWalletForm.value.amount,
          currencyCode:
            this.modal.context.account.currencyCode ||
            (this.modal.context.account.currencyId == 'naira' ? '₦' : '$'),
          beneficiary: res['paymentDetails']['company_name'],
          rrr: res['transactionRef'],
          description: res['paymentDetails']['description'],
          address: res['paymentDetails']['payers_address'],
          name: res['paymentDetails']['payers_name'],
          phone: res['paymentDetails']['payers_phone'],
          email: res['paymentDetails']['payers_email'],
          docPath: res['detailsDocumentPath'],
          paymentLink: res['paymentUrl'],
          internalTransactionRef: res['internalTransactionRef'],
        };
        const queryString = Object.keys(params)
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join('&');
        this.router.navigateByUrl(
          `/contractor/wallet/fund-wallet?` + queryString
        );
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error;
        this.pending = false;
      }
    );
  }

  formatAmount(amount: number) {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  dataToJSON(data: any) {
    return JSON.parse(data);
  }
}

export class FundWalletModal extends ComponentModalConfig<
  IFundWalletModalContext,
  void,
  void
> {
  constructor(account: any, size: ModalSize = ModalSize.Tiny) {
    super(FundWalletModalComponent, { account });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
